const styles = {
    exito: "text-sm text-lime-400",
    error: "text-red-500 text-sm",
}

export default styles